import { createIconComponent } from '../../factory/create-icon-component';
export const NewReplenishmentIcon = createIconComponent(
  'NewReplenishmentIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.49976 9.49958V17.2496C2.49976 17.9463 2.49976 18.2947 2.54305 18.5866C2.80157 20.3294 4.17001 21.6978 5.91283 21.9563C6.2047 21.9996 6.55305 21.9996 7.24976 21.9996L9.19157 21.9996M0.999756 10.9996L7.47427 4.52506C9.05834 2.94099 9.85037 2.14896 10.7637 1.85221C11.5671 1.59118 12.4325 1.59118 13.2358 1.85221C14.1491 2.14896 14.9412 2.94099 16.5252 4.52506L22.9998 10.9996"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.6499 12.0327L16.8339 10.3431C16.3477 10.0514 16.1046 9.90552 15.8451 9.84854C15.6156 9.79813 15.3778 9.79813 15.1483 9.84854C14.8888 9.90552 14.6457 10.0514 14.1595 10.3431L11.3435 12.0327L11.3435 12.0327C10.8834 12.3088 10.6533 12.4468 10.4862 12.6369C10.3383 12.8051 10.2268 13.002 10.1587 13.2153C10.0817 13.4564 10.0817 13.7247 10.0817 14.2613V16.7333C10.0817 17.2699 10.0817 17.5382 10.1587 17.7793C10.2268 17.9926 10.3383 18.1896 10.4862 18.3578C10.6533 18.5478 10.8834 18.6859 11.3435 18.9619L11.3435 18.9619L11.8867 19.2878L14.1177 20.6264C14.6182 20.9268 14.8685 21.0769 15.1352 21.1332C15.371 21.183 15.6149 21.1796 15.8493 21.1234C16.1143 21.0599 16.3604 20.9029 16.8526 20.589L20.0243 18.5658C20.3484 18.3591 20.5104 18.2557 20.6279 18.1168C20.7319 17.9939 20.8101 17.8513 20.8578 17.6975C20.9117 17.5238 20.9117 17.3316 20.9117 16.9471V14.2613C20.9117 13.7247 20.9117 13.4564 20.8348 13.2153C20.7666 13.002 20.6551 12.8051 20.5072 12.6369C20.3401 12.4468 20.11 12.3088 19.6499 12.0327Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0597 14.1441L16.162 12.2483"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4967 15.7681L20.3702 12.7898M15.4967 15.7681L10.6232 12.7898M15.4967 15.7681V21.1831"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
